export class CaptchaResponse {
  captchaKey: string;
  idempotentKey: string;
}
